/**
 * Fix Headings & Structure for Sycamore Den
 * Satisfies WCAG 1.3.1 (Info and Relationships)
 */
(function() {
  function fixHeadings() {
    // 1. Ensure at least one H1 exists
    const h1s = document.querySelectorAll('h1');
    if (h1s.length === 0) {
      // Find the most prominent heading or logo and make it an H1
      const logo = document.querySelector('.header__heading, .header__logo, .logo');
      if (logo) {
        const newH1 = document.createElement('h1');
        newH1.className = 'visually-hidden';
        // Use the site name from the title as a fallback
        const siteName = document.title.split('–')[0].trim() || 'Sycamore Den';
        newH1.textContent = siteName;
        document.body.prepend(newH1);
      }
    }

    // 2. Fix Heading Hierarchy (No skipping levels)
    const headings = document.querySelectorAll('h1, h2, h3, h4, h5, h6');
    let lastLevel = 1;

    headings.forEach(h => {
      const currentLevel = parseInt(h.tagName.substring(1));
      if (currentLevel > lastLevel + 1) {
        // If we skipped a level (e.g., H2 to H4), demote the current heading
        const correctedLevel = lastLevel + 1;
        const newTag = 'H' + correctedLevel;
        const newH = document.createElement(newTag);
        newH.innerHTML = h.innerHTML;
        newH.className = h.className;
        h.parentNode.replaceChild(newH, h);
        lastLevel = correctedLevel;
      } else {
        lastLevel = currentLevel;
      }
    });
  }

  // Run on load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixHeadings);
  } else {
    fixHeadings();
  }

  // Watch for dynamic content
  const observer = new MutationObserver(fixHeadings);
  observer.observe(document.body, { childList: true, subtree: true });
})();